var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-body"},[_c('div',{staticClass:"container"},[_c('b-alert',{attrs:{"variant":"warning","show":""}},[_vm._v(" No Access ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }